import { render, staticRenderFns } from "./_Variants.vue?vue&type=template&id=487fd07d&"
import script from "./_Variants.vue?vue&type=script&lang=js&"
export * from "./_Variants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports